<template>
  <el-container class="chat-box-warp">
    <!-- <header class="header-tabs">
      <header-jkt v-model="searchText" @copy-click="handCopyLink" @user-menu-command="handleUserMenuCommand" />
    </header> -->
    <el-container class="chat-page">
      <resizable-aside :default-width="320" :min-width="300" :max-width="500" storage-key="chat-aside-width"
        style="background-color: #fff">
        <!-- <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
          <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
            <i class="el-icon-search el-input__icon" slot="prefix"> </i>
          </el-input>
        </div> -->
        <div class="tab-box">
          <tab-jkt v-model="activeTab" :options="menuItemsWithBadge" aria-label="聊天选项卡" @change="handleTabChange" />
        </div>
        <!-- 当前会话 -->
        <template v-if="activeTab == 'current'">
          <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
            element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
          </div>
          <virtual-scroller class="scroll-box" :items="showChats">
            <template v-slot="{ item }">
              <chat-item :chat="item" @click.native="onActiveItem(item)" @delete="onDelItem(item)"
                @info="onShowInfo(item)" @dnd="onDnd(item)" @top="onTop(item)"
                :active="item === chatStore.activeChat"></chat-item>
            </template>
          </virtual-scroller>
        </template>
        <!-- 接入会话 -->
        <template v-if="activeTab == 'pending'">
          <div class="pending-tab">
            <tab-jkt v-model="pendingActiveTab" :options="pendingTabsBadge" aria-label="转接选项卡"
              @change="handlePendingTabChange" />
          </div>
          <div class="pending-list">
            <CusFixedList key="id" :items="pendingList" :loading="pendLoading" :item-size="64">
              <template #default="{ item }">
                <pending-transfer-item :item="item" :loading-action="pendingLoadingMap[item.id] || ''"
                  @accept="onPendingAccept" @reject="onPendingReject" />
              </template>
            </CusFixedList>
          </div>
        </template>
      </resizable-aside>
      <el-container class="chat-box">
        <chat-box v-if="activeChat && activeChat.type != 'SYSTEM'" :chat="activeChat" ref="backendChatBox"
          @update-customerInfo="handleUpdateCustomerInfo"></chat-box>
        <chat-system-box v-if="activeChat && activeChat.type == 'SYSTEM'" :chat="activeChat"></chat-system-box>
        <!-- 加一个空状态 -->
        <el-empty v-if="!activeChat" description="请选择左侧会话" :image-size="100" class="empty-state"> </el-empty>
      </el-container>
      <div class="info-detail">
        <!-- <customer-detail-card :detail="customerInfo" @block-user="handleBlockUser" :loading="blackLoading" /> -->
        <!-- <quick-reply-panel @apply-text="onQuickReplyApply" /> -->
        <customer-visual-profile :detail="customerInfo" @open-detail="handleVisitor"
          @remark-updated="onCustomerRemarkUpdated" />
        <quick-reply-visual-panel :chat="activeChat" @apply-text="onQuickReplyApply"
          @transfer-success="onQuickReplyTransferSuccess" />
      </div>
    </el-container>
    <!-- 客服连接modal -->
    <copy-url-dialog ref="copyUrlDialog"></copy-url-dialog>
    <customer-details-modal v-if="customerModalVisible" :visible.sync="customerModalVisible" :detail="customerInfo"
      @save="onCustomerDetailsSave" @blacklist-updated="onCustomerModalBlacklistUpdated"
      @block-ip="onCustomerModalBlockIp" />
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
import HeaderJkt from "../components/jkt/header-jkt.vue";
import TabJkt from "../components/jkt/tab-jkt.vue";
import PendingTransferItem from "../components/jkt/pending-transfer-item-v2.vue";
import CusFixedList from "../components/jkt/cus-recycle-scroller.vue";
import CopyUrlDialog from "../components/jkt/copy-url-dialog.vue";
import CustomerVisualProfile from "../components/jkt/customer-visual-profile.vue";
import QuickReplyVisualPanel from "../components/jkt/quick-reply-visual-panel.vue";
import CustomerDetailsModal from "../components/jkt/customer-details-modal.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    ResizableAside,
    VirtualScroller,
    HeaderJkt,
    TabJkt,
    PendingTransferItem,
    CustomerVisualProfile,
    QuickReplyVisualPanel,
    CusFixedList,
    CopyUrlDialog,
    CustomerDetailsModal
  },
  data() {
    return {
      searchText: "", // 搜索会话关键字
      messageContent: "",
      group: {},
      groupMembers: [],
      menuItems: [
        { value: "current", label: "当前会话" },
        // { value: "notify", label: "消息通知" },
        { value: "pending", label: "接入会话" }
      ],
      activeTab: "current", // 左侧标签页
      pendingTabs: [
        { value: "1", label: "待接受" },
        { value: "2", label: "已接受" },
        { value: "3", label: "已拒绝" },
        { value: "4", label: "已取消" }
      ], // 待处理会话标签页
      pendingActiveTab: "1", // 待处理会话标签页
      pendingLoadingMap: {}, // 待处理会话加载状态
      customerInfo: null, // 访客详情
      blackLoading: false, // 拉黑按钮状态
      customerModalVisible: false // 是否打开访客详情modal
    };
  },
  methods: {
    // 获取访客详情
    handleUpdateCustomerInfo(item) {
      console.log("访客详情", item);
      this.customerInfo = item;
    },
    onActiveItem(chat) {
      this.chatStore.setActiveChat(chat);
    },
    onDelItem(chat) {
      this.$confirm(`删除后记录将清空,确认删除与' ${chat.showName}'的聊天 ?`, "删除会话", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        if (chat.type == "PRIVATE" || chat.type == "GROUP") {
          const data = {
            chatId: chat.targetId
          };
          await this.$http({
            url: `/message/${chat.type.toLowerCase()}/deleteChat`,
            method: "delete",
            data: data
          });
        }
        this.chatStore.removeChat(chat);
      });
    },
    onShowInfo(chat) {
      if (chat.type == "PRIVATE") {
        this.$router.push("/home/friend?id=" + chat.targetId);
      } else if (chat.type == "GROUP") {
        if (!this.groupStore.isGroup(chat.targetId)) {
          this.$message.error("您已不在群聊中，无法查看群资料");
          return;
        }
        this.$router.push("/home/group?id=" + chat.targetId);
      }
    },
    onDnd(chat) {
      if (chat.type == "PRIVATE") {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd);
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd);
      }
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = {
        friendId: friendId,
        isDnd: isDnd
      };
      this.$http({
        url: "/friend/dnd",
        method: "put",
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd);
        this.chatStore.setDnd(chat, isDnd);
      });
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = {
        groupId: groupId,
        isDnd: isDnd
      };
      this.$http({
        url: "/group/dnd",
        method: "put",
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd);
        this.chatStore.setDnd(chat, isDnd);
      });
    },
    onTop(chat) {
      if (chat.type == "PRIVATE") {
        this.setFriendTop(chat, chat.targetId, !chat.isTop);
      } else {
        this.setGroupTop(chat, chat.targetId, !chat.isTop);
      }
    },
    setFriendTop(chat, friendId, isTop) {
      let formData = {
        friendId: friendId,
        isTop: isTop
      };
      this.$http({
        url: "/friend/top",
        method: "put",
        data: formData
      }).then(() => {
        this.friendStore.setTop(friendId, isTop);
        this.chatStore.setTop(chat, isTop);
      });
    },
    setGroupTop(chat, groupId, isTop) {
      let formData = {
        groupId: groupId,
        isTop: isTop
      };
      this.$http({
        url: "/group/top",
        method: "put",
        data: formData
      }).then(() => {
        this.groupStore.setTop(groupId, isTop);
        this.chatStore.setTop(chat, isTop);
      });
    },
    isShowChat(chat) {
      return !this.searchText || chat.showName.includes(this.searchText);
    },
    //tab栏切换
    handleTabChange(value) {
      this.activeTab = value;
      if (value === "pending") {
        this.getTransferList();
      }
    },
    /**
     * 快捷回复面板：将文本写入中间 BackendChatBox 输入区
     * @param {string} text
     */
    onQuickReplyApply(text) {
      if (text == null || String(text).trim() === "") {
        return;
      }
      if (!this.activeChat) {
        this.$message.warning("请先选择左侧会话");
        return;
      }
      this.$nextTick(() => {
        const box = this.$refs.backendChatBox;
        if (box && typeof box.applyQuickReplyText === "function") {
          box.applyQuickReplyText(String(text));
        } else {
          this.$message.warning("聊天输入框未就绪，请稍后再试");
        }
      });
    },
    /** 侧栏快捷回复面板发起转接成功：关闭聊天区内「选客服」浮层（与 ChatBox 内确认转接一致） */
    onQuickReplyTransferSuccess() {
      const box = this.$refs.backendChatBox;
      const keFu = box && box.$refs ? box.$refs.keFuBox : null;
      if (keFu && typeof keFu.close === "function") {
        keFu.close();
      }
    },
    // ========================接入会话相关===========================
    // 接入会话的tab切换
    handlePendingTabChange(val) {
      this.pendingActiveTab = val;
      this.getTransferList();
    },
    onPendingAccept(item) {
      this.handTrTransfer(item.id, true, item);
    },
    onPendingReject(item) {
      this.handTrTransfer(item.id, false, item);
    },
    /** 转接接口返回的聊天记录：兼容数组本体、res.messages、res.data */
    parseTransferHandleMessages(res) {
      if (Array.isArray(res)) {
        return res;
      }
      if (res && Array.isArray(res.messages)) {
        return res.messages;
      }
      if (res && res.data) {
        if (Array.isArray(res.data)) {
          return res.data;
        }
        if (Array.isArray(res.data.messages)) {
          return res.data.messages;
        }
      }
      return [];
    },
    // 处理转接
    handTrTransfer(id, accept, pendingItem) {
      const action = accept ? "accept" : "reject";
      this.$set(this.pendingLoadingMap, id, action);
      this.$http({
        url: "/customer/transfer/handle",
        method: "POST",
        data: {
          id: id,
          accept: accept
        }
      })
        .then((res) => {
          this.pendingTransferStore.removePendingById(id);
          if (accept) {
            this.$message.success("转接成功");
            const messages = this.parseTransferHandleMessages(res);
            const visitorInfo = pendingItem && pendingItem.visitorInfo;
            // 私聊会话的对方为访客，targetId 必须用 visitorInfo.id（勿用转接单 id 或其它字段）
            const visitorId = visitorInfo != null && visitorInfo.id != null ? visitorInfo.id : null;
            if (visitorId != null) {
              this.chatStore.replacePrivateChatMessagesFromServer({ type: "PRIVATE", targetId: visitorId }, messages, {
                showName: visitorInfo.nickName,
                headImage: visitorInfo.headImage || visitorInfo.headImageThumb,
                unreadCount: 0
              });
              this.chatStore.setActiveChat({ type: "PRIVATE", targetId: visitorId });
            }
          } else {
            this.$message.success("已拒绝");
          }
        })
        .finally(() => {
          this.$delete(this.pendingLoadingMap, id);
        });
    },
    // 获取接入会话（请求在 pendingTransferStore.loadTransferList，与 loadFriend 一致）
    getTransferList() {
      return this.pendingTransferStore.loadTransferList(this.pendingActiveTab);
    },

    //==================================================================
    //=================================拉黑 解除拉黑==================================
    handleBlockUser(item, val) {
      // val == 1  解除拉黑   == 2来黑
      console.log("拉黑", item, val);
      if (!item) {
        this.$message.error("请选择对应的访客");
      }
      if (val == 1) {
        this.handleRemoveFromBlacklist(item.id);
      } else if (val == 2) {
        this.handleAddToBlacklist(item.id);
      }
    },
    // 加入黑名单
    handleAddToBlacklist(id) {
      this.blackLoading = true;
      this.$http({
        url: "/user/addBlacklist?userId=" + id,
        method: "POST",
        data: {
          userId: id
        }
      })
        .then(() => {
          this.$message.success("加入黑名单成功");
          // 手动改变那个对象的属性detail.isIpBlacklist  使用$set
          this.$set(this.customerInfo, "isIpBlacklist", true);
          console.log("[[[[[]]]]]", this.customerInfo);
        })
        .finally(() => {
          this.blackLoading = false;
        });
    },
    //移除黑名单
    handleRemoveFromBlacklist(id) {
      this.blackLoading = true;
      this.$http({
        url: "/user/delBlacklist?userId=" + id,
        method: "POST",
        data: {
          userId: id
        }
      })
        .then(() => {
          this.$message.success("移出黑名单成功");
          this.$set(this.customerInfo, "isIpBlacklist", false);
        })
        .finally(() => {
          this.blackLoading = false;
        });
    },
    // ==================================================================

    // 打开客服连接modal
    handCopyLink() {
      this.$refs.copyUrlDialog.open(this.userStore.userInfo.serviceUrl);
    },
    // 设置的下拉菜单
    handleUserMenuCommand(command) {
      if (command === "modifyUserInfo") {
        this.$eventBus.$emit("openSettingUserInfo");
        return;
      }
      // if (command === "logout") {
      //   this.onExit();
      // }
    },
    // ================================ 访客详情 ==========================
    handleVisitor() {
      // const detail = item || this.customerInfo;
      // if (!detail) {
      //   this.$message.warning("暂无客户信息，请先进入会话");
      //   return;
      // }
      // this.$refs.customerDetailsModal.open(detail);
      this.customerModalVisible = true;
    },
    /** 侧栏备注与好友 store / 会话展示名同步 */
    onCustomerRemarkUpdated(friend) {
      if (!this.customerInfo || !friend || friend.id != this.customerInfo.id) {
        return;
      }
      const rn = friend.remarkNickName || "";
      this.$set(this.customerInfo, "remarkNickName", rn);
      this.$set(this.customerInfo, "showNickName", friend.showNickName || this.customerInfo.nickName);
      this.$set(this.customerInfo, "remark", rn);
    },
    onCustomerDetailsSave({ form }) {
      if (!this.customerInfo || !form) {
        return;
      }
      Object.keys(form).forEach((k) => {
        this.$set(this.customerInfo, k, form[k]);
      });
      // TODO: 对接保存客户详情接口
      this.$message.success("保存成功");
    },
    onCustomerModalBlacklistUpdated({ userId, isInBlacklist, isIpBlacklist }) {
      if (!this.customerInfo || this.customerInfo.id != userId) {
        return;
      }
      this.$set(this.customerInfo, "isIpBlacklist", !!isIpBlacklist);
    },
    onCustomerModalBlockIp() {
      // TODO: 对接屏蔽 IP 接口（可与 customerInfo.isIpBlacklist 联动）
      this.$message.info("屏蔽 IP 功能待对接接口");
    }
  },
  computed: {
    activeChat() {
      return this.chatStore.activeChat;
    },
    loading() {
      return this.chatStore.loading;
    },
    showChats() {
      return this.chatStore.chats.filter((chat) => this.isShowChat(chat));
    },
    /** 接入会话列表（当前子 Tab对应 status） */
    pendingList() {
      return this.pendingTransferStore.listForStatus(this.pendingActiveTab);
    },
    pendLoading() {
      return this.pendingTransferStore.listLoading;
    },
    /** 主 Tab 角标：当前会话 = 未读消息数；接入会话 = 待接受条数（与 store 同步，含 WS 推送） */
    menuItemsWithBadge() {
      const pendingCount = this.pendingTransferStore.acceptBadgeCount;
      const unread = this.unreadCount;
      return this.menuItems.map((m) => {
        if (m.value === "current") {
          return { ...m, badge: unread > 0 ? unread : undefined };
        }
        if (m.value === "pending") {
          return { ...m, badge: pendingCount > 0 ? pendingCount : undefined };
        }
        return { ...m };
      });
    },
    //子tab 也需要角标
    pendingTabsBadge() {
      const count = this.pendingTransferStore.acceptBadgeCount;
      return this.pendingTabs.map((m) => (m.value == "1" ? { ...m, badge: count > 0 ? count : undefined } : { ...m }));
    },
    //当前会话所有未读
    unreadCount() {
      let unreadCount = 0;
      let chats = this.chatStore.chats;
      chats.forEach((chat) => {
        if (!chat.delete && !chat.isDnd) {
          unreadCount += chat.unreadCount;
        }
      });
      return unreadCount;
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-box-warp {
  display: flex;
  flex-direction: column;
  // background-color: rebeccapurple;
  height: 100vh;
  height: calc(100vh - 65px) !important;
  min-height: 0;

  .header-tabs {
    // height: 55px;
    // min-height: 55px;
    box-sizing: border-box;
  }
}

.chat-page {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  // min-height: calc(100vh - 58px);

  // .header {
  //   height: 60px;
  //   display: flex;
  //   align-items: center;
  //   padding: 0 12px;
  // }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }

    .chat-loading-box {
      height: 100%;
    }
  }

  .chat-items {
    flex: 1;
  }
}

.tab-box {
  padding: 0 10px;
  box-sizing: border-box;
  margin: 10px 0;
}

.info-detail {
  width: 288px;
  min-width: 288px;
  // background: #f5f6f7;
  // border-left: 1px solid rgba(171, 173, 174, 0.1);
  border-left: 1px solid #e5e7eb;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  // box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.empty-state {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pending-tab {
  margin: 0 10px;
}

.pending-list {
  flex: 1;
  // height: calc(100vh - 60px - 72px);
  // padding: 0 10px 10px;
  box-sizing: border-box;
}
</style>
